import styled from "styled-components";

export const DonationTextBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const DonationFormLabel = styled.label`
    font-size: var(--font-size-sm);
    font-weight: 400;
    color: black;
    margin-bottom: 5px;
`

export const DonationFormInput = styled.input`
    border: var(--color-donation-input-border) 1px solid;
    border-radius: 5px;
    padding: 15px 20px;
    font-size: var(--font-size-sm);
    background-color: var(--color-donation-input);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02);
    @media (min-width: 1201px) {
        margin-right: 40px;
        margin-bottom: 40px;
    }
    @media (max-width: 1200px) {
        margin-bottom: 10px;
    }
`
